import axios from 'axios';
import config from '../config';

const addAmenities = async data => {
  const res = await axios.get(`${config.API_URL}/api/properties/amenities/`, data);
  return res?.data.results;
};

export default addAmenities;
